import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.i{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.ck{background:var(--shades-white);}.ssr-plugin'
import '.bz{flex-grow:1;}.ssr-plugin'
import '.c{align-items:center;}.ssr-plugin'
import '.b5{max-width:77.5rem;}.ssr-plugin'
import '.cl{justify-content:stretch;}.ssr-plugin'
import '.cm{position:sticky;}.ssr-plugin'
import '.cn{top:0px;}.ssr-plugin'
import '.co{z-index:10;}.ssr-plugin'
import '.cp{padding-block:1rem;}.ssr-plugin'
import '.cq{height:3rem;}.ssr-plugin'
import '.aa{justify-content:space-between;}.ssr-plugin'
import '.cr{flex-wrap:wrap;}.ssr-plugin'
import '.cs{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bg{margin-top:2rem;}.ssr-plugin'
import '.ct{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab i b ck"
      >
        <div className="bz a c i b"
        >
          <div className="b5 a b cl cm cn co ck"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="cp cq a aa c cr"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="cs a b ab bg ct b5"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
